import type { StateCreator } from 'zustand';
import type { StoreState, User } from '../types/types';
import { initialSessionState as noOpSession } from './schemas';
import { logger } from '../services/logger.client';

export interface AuthState {
    user: User | null;
    token: string | null;
}

export interface AuthActions {
    login: (user: User, token: string) => void;
    setToken: (token: string) => void;
    logout: () => Promise<void>;
}

export type AuthSlice = AuthState & AuthActions;

export const createAuthActions: StateCreator<StoreState, [['zustand/immer', never]], [], { state: AuthState, actions: AuthActions }> = (set) => ({
  state: {
    user: null,
    token: null,
  },
  actions: {
    login: (user, token) => {
      return new Promise((resolve) => {
        set(store => {
          store.auth.user = user;
          store.auth.token = token;
        });
        setTimeout(resolve, 0); // Allow persist middleware to run
      });
    },
    setToken: (token) => set(store => {
      store.auth.token = token;
    }),
    logout: async () => {
      logger.error({ timestamp: new Date().toISOString(), stack: new Error('logout called').stack }, '[AUTH-DEBUG] logout() called — token will be cleared');
      set(store => {
        store.auth.user = null;
        store.auth.token = null;
        // The `noOpSession` is defined in useGlobalState.ts and is a valid, empty session object.
      logger.info('authActions: Resetting session to no-op session.');
        store.session = noOpSession;
      });
    },
  }
});